import React, { useCallback } from 'react'
import { RoomTypes } from '@weblite/ts-action/room'
import { useRoom } from '$logic/room/react-hook'
import { UserListItemWithStatus } from '$common/room-list-search/user-list-item-with-status'
import { HallListItemWithStatus } from '$common/room-list-search/hall-list-item-with-status'
import { WappRoomListItemWithStatus } from '$common/room-list-search/wapp-room-list-item-with-status'
import { PrivateSpaceListItemWithStatus } from '$common/room-list-search/private-space-list-item-with-status'
import { nothing } from '$func/utils'
import { UserListItemSkeleton } from '$common/user-list-item'
import { addToRecentSearch } from '$logic/room-list/room-list-search.service'
import { openRoom } from '$logic/opened-room'

interface Props {
  roomId: string
  onSecondaryActionIconClick?: () => any
  selectionMap: Record<string, boolean>
  hasSelection: boolean
  onSelectedChange: (selected: boolean, chatId: string) => unknown
  onSelect: (selectedRoomId: string) => unknown
}

const componentMapper: Record<RoomTypes, any> = {
  CHANNEL: HallListItemWithStatus,
  GROUP: HallListItemWithStatus,
  PV: UserListItemWithStatus,
  WAPP_ROOM: WappRoomListItemWithStatus,
  PRIVATE_SPACE: PrivateSpaceListItemWithStatus,
}

export function RoomListItemWithStatus({
  roomId,
  onSecondaryActionIconClick = nothing,
  hasSelection,
  selectionMap,
  onSelectedChange,
  onSelect,
}: Props) {
  const room = useRoom(roomId)

  const { type } = room || {}
  const selected = selectionMap[roomId]

  const onClick = useCallback(() => {
    if (selected) onSelectedChange(false, roomId)
    else if (hasSelection) {
      onSelectedChange(true, roomId)
      addToRecentSearch({ id: roomId, type: 'ROOM' })
    } else if (onSelect) onSelect(roomId)
    else openRoom(roomId)
  }, [selected, hasSelection, roomId, onSelectedChange])

  const onContextMenu = useCallback(
    (e: Event) => {
      e.preventDefault()
      if (!hasSelection) {
        onSelectedChange(true, roomId)
        addToRecentSearch({ id: roomId, type: 'ROOM' })
      }
    },
    [hasSelection, onSelectedChange],
  )
  if (!room || !type) return <UserListItemSkeleton />

  const Component = componentMapper[type]

  return (
    <Component
      chatId={roomId}
      onSecondaryActionIconClick={onSecondaryActionIconClick}
      onClick={onClick}
      onContextMenu={onContextMenu}
      selected={selected}
    />
  )
}
